import React from 'react';
import { colors } from 'theme';
import { classNames } from 'primereact/utils';
import { ReactComponent as StarIcon } from '../../../assets/icons/new/star.svg';

interface MatchingOptionsProps {
	option: {
		area: string;
		match: boolean;
	};
}

const OptionItem = ({ option }: MatchingOptionsProps) => (
	<div className="flex pr-2 mb-2 align-items-center w-full md:w-2" style={{ minWidth: '24%' }}>
		<StarIcon width={22} height={21} className="mr-2 flex-shrink-0" style={{ color: colors.purplishBlue }} />
		<div className={classNames({ 'font-bold': option.match })}>{option.area}</div>
	</div>
);

export default OptionItem;
